import React from "react";
import LandingNavbar from "@/components/landing/LandingNavbar";

type LandingShellProps = {
  children: React.ReactNode;
  showSectionLinks?: boolean;
};

export default function LandingShell({ children, showSectionLinks = true }: LandingShellProps) {
  React.useLayoutEffect(() => {
    const root = document.documentElement;
    root.classList.add("allow-window-scroll");

    return () => {
      root.classList.remove("allow-window-scroll");
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <LandingNavbar showSectionLinks={showSectionLinks} />
      <div className="pt-16 md:pt-20">{children}</div>
    </div>
  );
}